import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { registerServiceWorker, captureInstallPrompt } from './pwa';

// Both at boot, before React renders: Chrome fires beforeinstallprompt once,
// early, and a listener mounted later never sees it.
captureInstallPrompt();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
